import React from 'react';

import crittercuddlerFilter from 'assets/images/crittercuddler-filter.png';
import overreactorFilter from 'assets/images/overreactor-filter.png';
import mamatobeFilter from 'assets/images/mamatobe-filter.png';
import homewreckerFilter from 'assets/images/homewrecker-filter.png';
import basicbreatherFilter from 'assets/images/basicbreather-filter.png';
import bigsneezeFilter from 'assets/images/bigsneeze-filter.png';
import rookieparentFilter from 'assets/images/rookieparent-filter.png';

import { FILTER_TYPES } from '../../../shared/enums';

/**
 * @param type
 * @param author
 * @param text
 * @return {JSX.Element}
 * @constructor
 */
const ClientQuote = ({
  type, author, text, isVisible,
}) => {
  const icons = Object.freeze({
    [FILTER_TYPES.BB]: basicbreatherFilter,
    [FILTER_TYPES.BS]: bigsneezeFilter,
    [FILTER_TYPES.RP]: rookieparentFilter,
    [FILTER_TYPES.CC]: crittercuddlerFilter,
    [FILTER_TYPES.HW]: homewreckerFilter,
    [FILTER_TYPES.MB]: mamatobeFilter,
    [FILTER_TYPES.OR]: overreactorFilter,
  });

  return (
    <div
      className={`grid-item client-quote ${isVisible} ${type}`}
      style={{ backgroundImage: `url(${icons[type] || overreactorFilter})` }}
    >
      <div className='client-quote__inner'>
        <blockquote className='client-quote__content'>
          <p>
            {text}
          </p>
          <footer>
            {author}
            .
          </footer>
        </blockquote>
        <a href='/buy' className='btn'>Order Now</a>
      </div>
    </div>
  );
};

export default ClientQuote;
